/// <reference path="references.ts" />
//Used in the HttpPostedFileBase editor template - scripts those inputs to show the name of the selected file
var HttpPostedFileBase = /** @class */ (function () {
    //Methods
    function HttpPostedFileBase(targetInputFile) {
        var thisObj = this;
        //Assign elements
        this.targetInputFile = targetInputFile;
        this.elLabelWrapper = targetInputFile.parentElement;
        this.elLabelSpan = this.elLabelWrapper.getElementsByTagName('span')[0];
        //All class to adjust styles
        this.elLabelWrapper.classList.add('HttpPostedFileBaseWrapper');
        if (this.targetInputFile.classList.contains('input-validation-error')) { //ASP.Net MVC - If a server-side validation error class was found on the <select>, apply it to the wrapper
            this.elLabelWrapper.classList.add('input-validation-error');
        }
        this.elLabelSpan.style.lineHeight = this.elLabelWrapper.offsetHeight.toString() + 'px'; //Set the line height of the label to the rendered height of the select to vertically center the content inside
        //Assign events
        $(thisObj.targetInputFile).on('change', function () {
            //Get the selected filename
            var filename = '';
            try {
                //Attempt to get the filename from available variables
                if (this.files) { //Attempt to use the files array first (should work in most newer browsers)
                    filename = this.files[0].name;
                }
                else { //Fallback for IE9 - have to strip off full directory path
                    filename = this.value.split(/(\\|\/)/g).pop();
                }
                //Truncate the filename if necessary
                if (filename.length > 24)
                    filename = filename.substring(0, 24) + '...';
            }
            catch (e) { //Worst-case fallback - just state that the file was selected
                filename = 'File Selected';
            }
            //Finally apply the formatted filename to the label
            thisObj.elLabelSpan.innerHTML = filename;
        });
    }
    return HttpPostedFileBase;
}());
//On page load, take all elements with the classname HttpPostedFileBase and create objects for them
var HttpPostedFileBaseList = [];
$(function () {
    var HttpPostedFileBasesByClass = document.getElementsByClassName("HttpPostedFileBase");
    for (var i = 0; i < HttpPostedFileBasesByClass.length; i++) {
        HttpPostedFileBaseList.push(new HttpPostedFileBase(HttpPostedFileBasesByClass.item(i)));
    }
    ;
});
//# sourceMappingURL=HttpPostedFileBase.js.map